import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Userdashboardheader from '../userdashboardheader/Userdashboardheader';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import Loader from '../Loader';
import axios from 'axios';

const Userdashboardtransactions = ({ route }) => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/login');
          return;
        }

        const response = await axios.get(`${route}/ledger/transactions`, {
          headers: {
            'x-access-token': token
          }
        });

        setTransactions(response.data);
      } catch (error) {
        console.error('Error fetching transactions:', error);
        setError('Failed to load transactions');
        if (error.response?.status === 401) {
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [route, navigate]);

  return (
    <div>
      <Userdashboardheader route={route} />
      {loading && <Loader />}
      
      <div className="page-swiper-wrapper">
        <div className="floating-btn" onClick={() => navigate('/fundwallet')}>
          <AiOutlineArrowLeft />
        </div>
        
        <div className="page-header">
          <h3>Your Funding History</h3>
          <h2>Transaction Logs</h2>
          <p>Track all your ledger funding transactions</p>
        </div>

        {error ? (
          <div className="error-message">
            <p>{error}</p>
          </div>
        ) : transactions.length === 0 ? (
          <div className="failure-page no-referral-page">
            <img src="/preview.gif" alt="" className="failure-img" />
            <p>No transactions found. Start by funding your ledger!</p>
            <button onClick={() => navigate('/fundwallet')} className="action-button">
              Fund Ledger
            </button>
          </div>
        ) : (
          <div className="transaction-container no-ref">
            <table>
              <thead>
                <tr>
                  <td>Transaction ID</td>
                  <td>Type</td>
                  <td>Method</td>
                  <td>Amount</td>
                  <td>Status</td>
                  <td>Date</td>
                </tr>
              </thead>
              <tbody>
                {transactions.map(transaction => (
                  <tr key={transaction._id}>
                    <td>{transaction._id}</td>
                    <td>{transaction.type}</td>
                    <td>{transaction.method}</td>
                    <td>${transaction.amount.toFixed(2)} USD</td>
                    <td>
                      <span className={`status ${transaction.status}`}>
                        {transaction.status}
                      </span>
                    </td>
                    <td>{new Date(transaction.createdAt).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Userdashboardtransactions;